import { observable, runInAction, action } from 'mobx'
import { hashHistory } from 'react-router'
import Api from '@api/live'
import { LIVE_MANAGE_PATH } from '@constant'

export default class {
  @observable title = '' // 直播标题
  @observable liveTime = '' // 直播时间
  @observable image_path = '' // 封面图地址
  @observable video_path = '' // 视频地址
  @observable packages = [] // 选中的套餐
  @observable cases = [] // 选中的案例
  @observable giftOfReservation = '' // 预约礼包
  @observable otherActivity = '' // 其他活动
  @observable watching_focus = [] //直播抽奖
  @observable status = null // 审核状态
  @observable auditing_remark = null // 审核结果
  @observable
  contactInformation = {
    name: '',
    tel: ''
  } // 对接人信息

  // 获取提报单信息
  init = async id => {
    const { success, data = {} } = await Api.reportFormData({ id })
    if (!success) {
      return
    }

    const {
      title,
      start_time,
      image_path,
      vertical_image_path,
      recommends,
      video_path,
      appointment_content,
      other_gift_content,
      docking_name,
      docking_tel,
      status,
      auditing_remark,
      watching_focus
    } = data
    runInAction(() => {
      this.id = id
      this.title = title
      this.liveTime = start_time
      this.image_path = image_path || '' // 直播封面
      this.vertical_image_path = vertical_image_path || '' // 直播封面
      this.video_path = video_path // 预热视频
      this.giftOfReservation = appointment_content
      this.otherActivity = other_gift_content
      this.status = status
      this.auditing_remark = auditing_remark
      this.watching_focus = watching_focus || []
      this.contactInformation = {
        name: docking_name,
        tel: docking_tel
      }

      if (!recommends) {
        return
      }
      // 案例和套餐
      const packages = recommends.find(r => r.type == 4)
      this.packages = packages ? packages.entity || [] : []
      const cases = recommends.find(r => r.type == 7)
      this.cases = cases ? cases.entity || [] : []
    })
  }

  @action
  goBack = () => {
    hashHistory.push(LIVE_MANAGE_PATH)
  }
  /**跳转优秀案例 */
  @action
  gotoSuperCase = () => {
    hashHistory.push(`${LIVE_MANAGE_PATH}/reportFormSuperCase`)
  }
}
